var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"c-drag-select",staticStyle:{"user-select":"none","touch-action":"none"},attrs:{"id":"container"}},[_c('div',{ref:"box",staticClass:"c-drag-select__box",style:(_vm.computedStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }